module.exports = __webpack_public_path__ + "static/examp7-e0eb36afec1f8917968e8e5d916beb63.gif";